import { render, staticRenderFns } from "./AIChatWidget.vue?vue&type=template&id=7dc8b447&scoped=true&"
import script from "./AIChatWidget.vue?vue&type=script&lang=js&"
export * from "./AIChatWidget.vue?vue&type=script&lang=js&"
import style0 from "./AIChatWidget.vue?vue&type=style&index=0&id=7dc8b447&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc8b447",
  null
  
)

export default component.exports